import axios from "axios";
import { getToken, removeToken } from "@/utils/auth";
import router from "../router";
import { getBaseURL } from "./appConfig";

const baseURL = getBaseURL();

const axiosIns = axios.create({
  baseURL
});

// request interceptor
axiosIns.interceptors.request.use(
  (config) => {
    const token = getToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// response interceptor
axiosIns.interceptors.response.use(
  (response) => response,
  (error) => {
    // error debugging
    if (error.response && error.response.status === 403) {
      // remove deprecated token
      removeToken();
      router.push("/login");
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export default axiosIns;



// WEBPACK FOOTER //
// ./src/utils/request.js